import AppModals from './app-modals.jsx';

export default AppModals;
